import axios from 'axios';
import store from '../store'
import verifyAuth from '../services/utilities'

class AuthRepository {

    constructor(){
        this.basePath = store.state.backend;
    }

    getUsernameFromEmail(email){
        return axios.get(`${this.basePath}/ext/users/username/by-email/${email}`);
    }

    editProfile(profileData) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/ext/users/edit`, profileData,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    getLanguage() {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/users/language`,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    editLanguage(languageData) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/ext/users/language`, languageData,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    editVisibility(visibilityData) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/ext/users/visibility/edit`, visibilityData,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    existingUsernameOrEmail(username, email){
        return axios.get(`${this.basePath}/ext/users/exists?username=${username}&email=${email}`);
    }

    // Deprecated Endpoint
    registerUser(userData) {
        return axios.post(`${this.basePath}/register-user`, userData);
    }

    registerCollapsedUser(userData) {
        return axios.post(`${this.basePath}/register-collapsed`, userData);
    }

    completeUserRegister(userData) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/ext/users/complete-register`, userData,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    confirmedEmail(email, key) {
        return axios.get(`${this.basePath}/activate?email=${email}&key=${key}`);
    }

    resetPassword(email) {
        return axios.post(`${this.basePath}/account/reset-password/init`, email);
    }

    requestActivationKey(email) {
        return axios.post(`${this.basePath}/account/get-activation-key`, email);
    }

    finishResetPassword(password, key) {
        return axios.post(`${this.basePath}/account/reset-password/finish`, {newPassword: password, key: key});
    }

    login(username, password) {
        let body = { username: username, password: password };
        return axios.post(`${this.basePath}/authenticate`, body);
    }

    logout(username) {
        let headers = {'Authorization': store.state.token};
        return axios.get(`${this.basePath}/authenticate/${username}`, {headers: headers});
    }

    analyzeNewUserLogin(userId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/users/analyze-login/${userId}`, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    getUser() {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/account`, {headers: headers});
        response = verifyAuth(response) 
        return response;
        //return axios.get(`${this.basePath}/account`, {headers: headers});
    }

    getUserDetails() {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/user-details/user`, {headers: headers});
        response = verifyAuth(response) 
        return response;
        //return axios.get(`${this.basePath}/ext/user-details/user`, {headers: headers});
    }

    isPro(){
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/user-details/user/pro`, {headers: headers});
        response = verifyAuth(response) 
        return response;
        //return axios.get(`${this.basePath}/ext/user-details/user/pro`, {headers: headers});
    }

    changeAutomationToken() {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/user-details/change-automation`, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    unpairTelegram() {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/user-details/unpair-telegram`, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    updateUserAvatar(formData){
        let headers = {'Authorization': store.state.token};
        let response = axios.put(`${this.basePath}/ext/user-details/user-avatar`,formData,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    syncAuthorizationResponse(syncResponse) {
        let response = axios.post(`${this.basePath}/ext/sync-authorizations/response`, syncResponse);
        response = verifyAuth(response) 
        return response;
    }
}

export default new AuthRepository();
